/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_DescriptionInputs */



/**
* | output |
* | --- |
* | "Enter your email and we'll send you a sign-in link. No password needed." |
*
* @param {Canvas_Sign_In_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_description = /** @type {((inputs?: Canvas_Sign_In_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie Ihre E-Mail-Adresse ein, wir senden Ihnen einen Anmeldelink. Ein Passwort brauchen Sie nicht.")
	return /** @type {LocalizedString} */ ("Enter your email and we'll send you a sign-in link. No password needed.")
});